const type = '[PLANNING_BOARD]';

export const SET_FULLSCREEN = `${type} SET_FULLSCREEN`;
export const SET_VIEW_MODE = `${type} SET_VIEW_MODE`;

export const TOGGLE_SHOW_TRAVEL_TIME = `${type} TOGGLE_SHOW_TRAVEL_TIME`;

export const RESET_NOTIFICATION = `${type} RESET_NOTIFICATION`;
